import { Box } from '@chakra-ui/react';
import React from 'react';

import Brand from '../Brand';
import Button from '../Button';
import Container from '../Container';
import GetStartedModal from '../Header/Navigation/MainNavigation/GetStartedModal';
import ImageHandler from '../ImageHandler';
import Link from '../Link';
import * as Styles from './SimpleHeader.module.scss';

interface SimpleHeaderProps {
  sticky: boolean;
  image?: {
    image: StaticImageDef | React.ReactElement;
    href: string;
  };
  action: {
    color: 'blue' | 'red';
    href: string;
    label: string;
  };
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({
  sticky,
  image,
  action,
}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Box
      as="header"
      boxShadow={
        sticky
          ? '0 10px 20px rgb(0 0 0 / 19%), 0 6px 6px rgb(0 0 0 / 23%)'
          : undefined
      }
      position={sticky ? 'sticky' : undefined}
      className={Styles.SimpleHeader}
    >
      <Container width="WIDE" className={Styles.SimpleHeaderContainer}>
        <Link className={Styles.SimpleHeaderLogo} to="/" variant="plain">
          <Brand />
        </Link>
        {image && (
          <Link to={image.href} display={{ base: 'none', md: 'unset' }}>
            <ImageHandler image={image.image} />
          </Link>
        )}
        <Box>
          {action && (
            <>
              <Button
                variant="solid"
                colorScheme={action.color}
                className={Styles.SimpleHeaderButton}
                onClick={() => setOpen(true)}
              >
                {action.label}
              </Button>
              <GetStartedModal
                refPage={action.href as string | null | undefined}
                open={open}
                onClose={() => setOpen(false)}
              />
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default SimpleHeader;
